import Icon from '../components/Icon.vue'

Icon.register({
  'thumbs-up': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M104 224c13.3 0 24 10.7 24 24v240c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-240c0-13.3 10.7-24 24-24h80zM64 472c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zM384 81.5c0 42.4-26 66.2-33.3 94.5h101.7c33.4 0 59.4 27.7 59.6 58.1 0.1 17.9-7.5 37.2-19.4 49.2l-0.1 0.1c9.8 23.3 8.2 56-9.3 79.5 8.7 25.9-0.1 57.7-16.4 74.8 4.3 17.6 2.2 32.6-6.1 44.6-20.4 29.3-71 29.7-113.8 29.7l-2.8 0c-48.3 0-87.8-17.6-119.6-31.7-16-7.1-36.8-15.9-52.7-16.2-6.5-0.1-11.8-5.5-11.8-12v-213.8c0-3.2 1.3-6.3 3.6-8.5 39.6-39.1 56.6-80.6 89.1-113.1 14.8-14.8 20.2-37.2 25.4-58.9 4.4-18.5 13.7-57.8 33.9-57.8 24 0 72 8 72 81.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/thumbs-up.js
// module id = 2007
// module chunks = 0